import { useCallback, useMemo } from 'react';
import { Feature, UserSetting } from 'src/WebApiController';

import { useUserHasFeature } from './useUserHasFeature';
import { useServerUserSetting } from './useUserSetting';

export const useFavoriteVendorIds = () => {
  const hasFavoriteVendorsFeature = useUserHasFeature(Feature.FavoriteVendors);

  const { value: _favoriteVendorIds, setUserSetting: _setFavoriteVendorIds } =
    useServerUserSetting<number[]>({
      id: UserSetting.FavoriteVendorIds,
    });

  const favoriteVendorIds = useMemo(() => {
    if (!hasFavoriteVendorsFeature) {
      return [];
    }
    return _favoriteVendorIds ?? [];
  }, [hasFavoriteVendorsFeature, _favoriteVendorIds]);

  const setFavoriteVendorId = useCallback(
    (id: number, isFavorite: boolean) => {
      if (hasFavoriteVendorsFeature) {
        if (isFavorite) {
          _setFavoriteVendorIds(
            favoriteVendorIds.filter((favId) => favId !== id)
          );
        } else {
          _setFavoriteVendorIds([...favoriteVendorIds, id]);
        }
      }
    },
    [favoriteVendorIds, _setFavoriteVendorIds, hasFavoriteVendorsFeature]
  );

  return {
    favoriteVendorIds,
    setFavoriteVendorId,
  };
};
